module.exports = __webpack_public_path__ + "static/img/icon.2486257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = fqxG
// module chunks = 1